
import ProductService from '../Services/ProductService';


export const getProductDetails = () => async (dispatch) => {
    try {
        const res = await ProductService.getProductDetails();
        
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};
